import { styled } from '@streem/ui-react';

export const MediaGalleryHeader = styled.h2(({ theme }) => ({
    marginBottom: '1rem',
    fontSize: theme.text.size.medium,
    lineHeight: theme.text.lineHeight.medium,
    fontFamily: theme.text.headingFontFamily,
    fontWeight: 500,
}));

export const MAX_VIDEO_HEIGHT = '25rem';
export const MAX_VIDEO_WIDTH = '44.5rem';
export const SECTION_HEADER_HEIGHT = '2.25rem';
export const MAX_VIDEO_SECTION_HEIGHT = '27.75rem'; // MAX_VIDEO_HEIGHT + SECTION_HEADER_HEIGHT
